import { gql } from "graphql-request";

export const ADMIN_SUBSCRIPTIONS = gql`
  query AdminSubscriptions($input: AdminSubscriptionsInputDto!) {
    adminSubscriptions(input: $input) {
      items {
        subscriptionId
        userId
        userEmail
        userName
        userCredits {
          monthly
          purchased
        }
        plan
        price
        subscriptionCycle
        status
        platform
        nextPaymentDate
        createdAt
        updatedAt
      }
      meta {
        totalCount
        totalPages
        currentPage
        limit
        hasNextPage
        hasPrevPage
      }
    }
  }
`;

export const ADMIN_SUBSCRIPTION_ANALYTICS = gql`
  query AdminSubscriptionAnalytics {
    adminSubscriptionAnalytics {
      breakdown {
        plan
        subscriptionCycle
        platform
        count
      }
      mrrKrw
      arrKrw
      pendingCancellationCount
    }
  }
`;

export const ADMIN_SUBSCRIPTION_TREND = gql`
  query AdminSubscriptionTrend($days: Int) {
    adminSubscriptionTrend(days: $days) {
      date
      breakdown {
        plan
        subscriptionCycle
        platform
        count
      }
    }
  }
`;

export const ADMIN_REFUNDABLE_PAYMENT = gql`
  query AdminRefundablePayment($userId: String!) {
    adminRefundablePayment(userId: $userId) {
      refundable
      refundMode
      requiresAmount
      freeOnlyAvailable
      currency
      platform
      paymentKey
      totalAmount
      balanceAmount
      method
      status
      approvedAt
      reason
    }
  }
`;
